export enum MessagingAvailabilityReason {
  LOADING = 'loading',
  AVAILABLE = 'available',
  UNSUPPORTED_LOCALE = 'unsupported locale',
  LIVE_ENGAGE_ERROR = 'live engage error',
  LIVE_ENGAGE_CLEANING_ERROR = 'live engage cleaning error',
  TIMEOUT = 'timeout',
  DISABLED = 'disabled',
  PILLOW_TALK_ERROR = 'pillow talk error',
}

export interface MessagingStatus {
  isAvailable: boolean;
  reason: MessagingAvailabilityReason;
}

export interface MessagingType {
  status: MessagingStatus;
  startMessaging?: () => void;
}

export const DEFAULT_STATUS: Readonly<MessagingStatus> = {
  isAvailable: false,
  reason: MessagingAvailabilityReason.LOADING,
};

export const DISABLED_STATUS: Readonly<MessagingStatus> = {
  isAvailable: false,
  reason: MessagingAvailabilityReason.DISABLED,
};
